/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterLicenseTypeAddPost } from '../fn/license-type/api-master-license-type-add-post';
import { ApiMasterLicenseTypeAddPost$Params } from '../fn/license-type/api-master-license-type-add-post';
import { apiMasterLicenseTypeDeleteGet } from '../fn/license-type/api-master-license-type-delete-get';
import { ApiMasterLicenseTypeDeleteGet$Params } from '../fn/license-type/api-master-license-type-delete-get';
import { apiMasterLicenseTypeEditPost } from '../fn/license-type/api-master-license-type-edit-post';
import { ApiMasterLicenseTypeEditPost$Params } from '../fn/license-type/api-master-license-type-edit-post';
import { apiMasterLicenseTypeGetActiveGet } from '../fn/license-type/api-master-license-type-get-active-get';
import { ApiMasterLicenseTypeGetActiveGet$Params } from '../fn/license-type/api-master-license-type-get-active-get';
import { apiMasterLicenseTypeGetAllGet } from '../fn/license-type/api-master-license-type-get-all-get';
import { ApiMasterLicenseTypeGetAllGet$Params } from '../fn/license-type/api-master-license-type-get-all-get';
import { apiMasterLicenseTypeGetByCriteriaPost } from '../fn/license-type/api-master-license-type-get-by-criteria-post';
import { ApiMasterLicenseTypeGetByCriteriaPost$Params } from '../fn/license-type/api-master-license-type-get-by-criteria-post';
import { Int32ApiRespModel } from '../models/int-32-api-resp-model';
import { LicenseType } from '../models/license-type';
import { LicenseTypeApiRespModel } from '../models/license-type-api-resp-model';

@Injectable({ providedIn: 'root' })
export class LicenseTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterLicenseTypeAddPost()` */
  static readonly ApiMasterLicenseTypeAddPostPath = '/api/Master/LicenseType/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterLicenseTypeAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterLicenseTypeAddPost$Response(params?: ApiMasterLicenseTypeAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LicenseTypeApiRespModel>> {
    return apiMasterLicenseTypeAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterLicenseTypeAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterLicenseTypeAddPost(params?: ApiMasterLicenseTypeAddPost$Params, context?: HttpContext): Observable<LicenseTypeApiRespModel> {
    return this.apiMasterLicenseTypeAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<LicenseTypeApiRespModel>): LicenseTypeApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterLicenseTypeEditPost()` */
  static readonly ApiMasterLicenseTypeEditPostPath = '/api/Master/LicenseType/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterLicenseTypeEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterLicenseTypeEditPost$Response(params?: ApiMasterLicenseTypeEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LicenseTypeApiRespModel>> {
    return apiMasterLicenseTypeEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterLicenseTypeEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterLicenseTypeEditPost(params?: ApiMasterLicenseTypeEditPost$Params, context?: HttpContext): Observable<LicenseTypeApiRespModel> {
    return this.apiMasterLicenseTypeEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<LicenseTypeApiRespModel>): LicenseTypeApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterLicenseTypeDeleteGet()` */
  static readonly ApiMasterLicenseTypeDeleteGetPath = '/api/Master/LicenseType/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterLicenseTypeDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterLicenseTypeDeleteGet$Response(params?: ApiMasterLicenseTypeDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
    return apiMasterLicenseTypeDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterLicenseTypeDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterLicenseTypeDeleteGet(params?: ApiMasterLicenseTypeDeleteGet$Params, context?: HttpContext): Observable<Int32ApiRespModel> {
    return this.apiMasterLicenseTypeDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiRespModel>): Int32ApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterLicenseTypeGetAllGet()` */
  static readonly ApiMasterLicenseTypeGetAllGetPath = '/api/Master/LicenseType/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterLicenseTypeGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterLicenseTypeGetAllGet$Response(params?: ApiMasterLicenseTypeGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LicenseType>>> {
    return apiMasterLicenseTypeGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterLicenseTypeGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterLicenseTypeGetAllGet(params?: ApiMasterLicenseTypeGetAllGet$Params, context?: HttpContext): Observable<Array<LicenseType>> {
    return this.apiMasterLicenseTypeGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LicenseType>>): Array<LicenseType> => r.body)
    );
  }

  /** Path part for operation `apiMasterLicenseTypeGetActiveGet()` */
  static readonly ApiMasterLicenseTypeGetActiveGetPath = '/api/Master/LicenseType/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterLicenseTypeGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterLicenseTypeGetActiveGet$Response(params?: ApiMasterLicenseTypeGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LicenseType>>> {
    return apiMasterLicenseTypeGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterLicenseTypeGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterLicenseTypeGetActiveGet(params?: ApiMasterLicenseTypeGetActiveGet$Params, context?: HttpContext): Observable<Array<LicenseType>> {
    return this.apiMasterLicenseTypeGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LicenseType>>): Array<LicenseType> => r.body)
    );
  }

  /** Path part for operation `apiMasterLicenseTypeGetByCriteriaPost()` */
  static readonly ApiMasterLicenseTypeGetByCriteriaPostPath = '/api/Master/LicenseType/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterLicenseTypeGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterLicenseTypeGetByCriteriaPost$Response(params?: ApiMasterLicenseTypeGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LicenseType>>> {
    return apiMasterLicenseTypeGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterLicenseTypeGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterLicenseTypeGetByCriteriaPost(params?: ApiMasterLicenseTypeGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<LicenseType>> {
    return this.apiMasterLicenseTypeGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<LicenseType>>): Array<LicenseType> => r.body)
    );
  }

}
